import CORE_SETTINGS from 'core/settings';
import { DEVELOPMENT, KEY_DEVELOP_MODE } from 'const';
import Cookies from 'js-cookie';

export const getStorageDevelopMode = (): boolean =>
  CORE_SETTINGS.environment === DEVELOPMENT ? !!Cookies.get(KEY_DEVELOP_MODE) : false;
export const onStorageDevelopMode = () =>
  Cookies.set(KEY_DEVELOP_MODE, 'ON', {
    sameSite: 'Strict',
    secure: true,
  });
export const offStorageDevelopMode = () => Cookies.remove(KEY_DEVELOP_MODE);
